import React from "react";
import { Row, Col, Modal, Button, FormInstance } from "antd";
import { useWindowSize } from "../../../hooks/useWindowSize";
import styles from "./PersonModals.module.scss";
import crossMark from "../../../assets/images/CrossMark.png";
import { Address, UspsAddresses } from "../../../types/LocationTypes";

type Props = {
  form: FormInstance;
  uspsAddresses: UspsAddresses;
  visible: boolean;
  setVisibility: Function;
  handleSubmitForm: Function;
};

function UspsAddressModal({
  form,
  visible,
  setVisibility,
  uspsAddresses,
  handleSubmitForm,
}: Props) {
  const { width } = useWindowSize();
  const { homeAddress, mailingAddress, deliveryAddress } = uspsAddresses;

  function handleCancel() {
    setVisibility(false);
  }

  function handleContinue() {
    homeAddress &&
      form.setFieldsValue({
        homeAddress,
      });
    mailingAddress &&
      form.setFieldsValue({
        mailingAddress,
      });
    deliveryAddress &&
      form.setFieldsValue({
        deliveryAddress,
      });
    setVisibility(false);
    handleSubmitForm();
  }

  function renderAddress(title: string, address: Address) {
    return (
      <Row className={styles.uspsAddress}>
        <Col span={24}>{title}</Col>
        <Col span={24}>{address.address1}</Col>
        <Col span={24}>{address.address2}</Col>
        <Col span={24}>
          {address.city}, {address.state} {address.zip}
        </Col>
      </Row>
    );
  }

  return (
    <Modal
      visible={visible}
      className={styles.uspsAddressModalContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "546px"}
      closeIcon={<img src={crossMark} alt="close" />}
      footer={
        <Row justify="center" gutter={[10, 15]}>
          <Col>
            <Button className={styles.cancel} onClick={handleCancel}>
              Cancel
            </Button>
          </Col>
          <Col>
            <Button className={styles.continue} onClick={handleContinue}>
              Continue
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center">
        <Col span={24} className={styles.title}>
          Updated Address Found
        </Col>

        <Col span={24} className={styles.uspsSubTitle}>
          USPS has provided the following updated address information:
        </Col>
        <Col
          span={24}
          className={
            homeAddress && mailingAddress
              ? styles.differentAddressLayout
              : styles.sameAddressLayout
          }
        >
          {homeAddress && renderAddress("Home Address", homeAddress)}
          {mailingAddress && renderAddress("Mailing Address", mailingAddress)}
          {deliveryAddress &&
            renderAddress("Delivery Address", deliveryAddress)}
        </Col>
        <Col span={24} className={styles.uspsSubTitle}>
          Please select Cancel make additional updates or Continue to use these
          addresses
        </Col>
      </Row>
    </Modal>
  );
}

export default UspsAddressModal;
